import { Modal } from '@fortress-technology-solutions/fortress-component-library/Molecules_Fortress';
import {
  Typography,
  Button,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';

const SaveAndCloseModal = ({ open, onClose, onSaveAndClose }) => {
  return (
    <Modal
      title="Save & Close"
      open={open}
      onClose={onClose}
      actions={
        <>
          <Button variant="text" color="primary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onSaveAndClose}>
            Save & Close
          </Button>
        </>
      }
    >
      <Typography variant="bodyMedium">
        Are you sure you want to save changes to this application?
      </Typography>
    </Modal>
  );
};

export default SaveAndCloseModal;
